import { createIcon } from '../shared'

const CommentIcon = createIcon(
  ({ color }) => (
    <path
      d="M1.07871 10.3214C0.583655 5.2955 4.7939 1.08168 9.81797 1.5773H9.8209C13.608 1.96695 16.6524 5.04532 16.9361 8.87613H16.9352C17.0684 10.459 16.7216 11.9468 16.0475 13.216L16.9176 16.6359C16.9739 16.8578 16.9094 17.093 16.7477 17.255C16.5856 17.4171 16.3496 17.4824 16.1275 17.4259L12.7096 16.5548C11.4323 17.2311 9.94683 17.5445 8.38047 17.4445L8.37266 17.4435C4.57848 17.1595 1.46818 14.1153 1.07871 10.3244V10.3214ZM9.69004 2.87027C5.48305 2.45548 1.95775 5.98348 2.37266 10.1945H2.37168C2.6983 13.3598 5.30463 15.9063 8.46153 16.1466H8.4625C9.87189 16.2367 11.1755 15.9361 12.2613 15.3195L12.3365 15.2834C12.4143 15.2516 12.4981 15.2345 12.5826 15.2345H12.7125L12.7926 15.2404C12.8195 15.2437 12.8463 15.2483 12.8727 15.255L15.3873 15.8957L14.7477 13.3781C14.7343 13.3257 14.7272 13.2719 14.7272 13.2179V13.088C14.7272 12.9756 14.7567 12.8645 14.8121 12.7668C15.4332 11.6716 15.7585 10.371 15.6402 8.97965L15.6393 8.97281C15.4029 5.77903 12.8578 3.19725 9.69004 2.87027Z"
      fill={color}
    />
  ),
  '0 0 18 18',
  'ThreadsCommentIcon',
)

export { CommentIcon }
